export default __webpack_public_path__ + "static/media/FSKoopman-Regular.09d84b42.woff2";